import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import BackArrow from '../../../../assets/backArrow';
import DownArrowIcon from '../../../../assets/downArrowIcon';
import RightArrow from '../../../../assets/rightArrow';
import SelectCreditTable from 'src/components/TablesAllInvoices/SelectCredit';
import './ManuallyCredit.scss';
import SelectedDebitInvoiceTable from 'src/components/TablesAllInvoices/SelectedDebitInvoice';
import InvoiceModel from 'src/model/invoice.model';
import invoiceServiceInstance from 'src/services/invoice/InvoiceService';
import CloseIcon from '../../../../assets/close';
import Input from 'src/components/common/Input';
import Modal from 'src/components/common/Modal';
import { Alert } from '@material-ui/lab';
import { Collapse, IconButton } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import { removeColumnOrganiser } from 'src/utils/commonUtils';
import i18n from 'src/translation/i18n';
interface IManualCreditProps extends RouteComponentProps {
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  handlePagination: (event: any) => void;
  handlePageSizeChange?: (pageSize: number) => void;
  getselectCredit?: () => void;
  selectCreditInvoices?: InvoiceModel[];
  selectedInvoices?: InvoiceModel[];
  selectedCreditInvoices?: InvoiceModel[];
  continue?: any;
  totalCreditmanual: number;
  totalDebitmanual: number;
  orderNumber: number;
  orderlist: number[];
  invoicelist: number[];
  transactionId: number[];
  isPending: any;
}
interface IManualCreditState {
  searchValue: any;
  creditamount: number;
  listOfOrdernumbers: number[];
  listOfInvoices: number[];
  creditUsed: number;
  editval: number;
  debiteditval: number;
  selectedCredit: [];
  selectedDebit: number;
  input: any;
  signature: any;
  showdisabledPopup: boolean;
  selectedCreditData: any[];
  applyCreditErrormessage: any;
  selectedDebitData: any[];
  showCreditTable: boolean;
  onCreditSummary: boolean;
  showPayDisabledPopup: boolean;
  payAmount: boolean;
}
export const SEARCH_FILTER_MAPPING = {
  'INv.No': 'invoiceNumber'
};

class ManuallyCredit extends React.Component<
  IManualCreditProps,
  IManualCreditState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      creditamount: 0,
      listOfOrdernumbers: [],
      listOfInvoices: [],
      // creditData: [],
      searchValue: '',
      creditUsed: 0,
      editval: 0,
      debiteditval: 0,
      selectedCredit: [],
      selectedDebit: 0,
      input: '',
      signature: '',
      showdisabledPopup: false,
      selectedCreditData: this.props.selectedCreditInvoices,
      selectedDebitData: this.props.selectedInvoices,
      applyCreditErrormessage: '',
      showCreditTable: false,
      onCreditSummary: false,
      showPayDisabledPopup: false,
      payAmount: false
    };
  }

  public payRemaining = () => {
    const state: any = this.props.location?.state;
    if (this.state.selectedCreditData.length > 0 && !state.continue) {
      this.setState({ showPayDisabledPopup: true });
    } else {
      this.props.history.push({
        pathname: '/invoices/payRemaining',
        state: {
          debitAmount:
            state && this.state.selectedDebit === 0
              ? state['selectedDebit'].toFixed(2)
              : this.state.selectedDebit.toFixed(2),
          selectedDebitData: this.state.selectedDebitData,
          navigateTo: 'manualCredit',
          backSelectedDebit: state['selectedDebit']
        }
      });
    }
  };

  private handleInput = (value: string) => {
    this.setState({ input: value });
  };
  public clickclose = () => {
    this.setState({ showdisabledPopup: false, showPayDisabledPopup: false });
  };
  public showPopup = () => {
    const locationStateDebit = this.props.location?.state['selectedDebit'];
    const locationStateCredit = this.props.location?.state['selectedCredit'];
    const selectDebitData =
      this.state.selectedDebit === 0
        ? locationStateDebit
        : this.state.selectedDebit;
    const selectCreditData =
      this.state.creditamount === 0
        ? locationStateCredit
        : this.state.creditamount;
    // if (Math.abs(selectCreditData) >= selectDebitData) {
    //   this.setState({ showdisabledPopup: true, applyCreditErrormessage: '' });
    // } else

    if (!selectCreditData || Math.abs(selectCreditData) === 0) {
      this.setState({
        applyCreditErrormessage: i18n.t(
          'invoices.toContinueMakeSuretoSelectOneorMoreCreditInvoices'
        )
      });
    } else {
      this.setState({ showdisabledPopup: true, applyCreditErrormessage: '' });
    }

    // else if (Math.abs(selectCreditData) < selectDebitData) {
    //   this.setState({
    //     applyCreditErrormessage: i18n.t('invoices.message1')
    //   });
    // }
  };

  public onClickCreditSummary = () => {
    const selectCreditData = this.state.creditamount;
    if (!selectCreditData || Math.abs(selectCreditData) === 0) {
      this.setState({
        applyCreditErrormessage: i18n.t('invoices.message2')
      });
    } else {
      this.setState({ onCreditSummary: true, applyCreditErrormessage: '' });
    }
  };

  public onCancelCredit = () => {
    this.setState({
      showCreditTable: false,
      selectedCreditData: []
    });
    this.props.getselectCredit();
  };

  public arrowBack = () => {
    this.props.history.push('/invoices');
  };
  public applyCredits = () => {
    this.setState({ signature: this.state.input }, () => this.clickCredit());
    this.setState({ showdisabledPopup: false });
  };
  private handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({ searchValue: event.currentTarget.value });
    let searchValue: any = event.currentTarget.value;
    let searchKey: any = SEARCH_FILTER_MAPPING[searchValue];
    // this.props.searchFilter ? this.props.searchFilter : null;
    searchValue = null;
    searchKey = null;
    this.props.getselectCredit();
  };

  public editdatadebit = (debitdata: any) => {
    this.setState({
      debiteditval: debitdata[3]
    });
  };

  public handleShortPayErrorFn = () => {
    this.setState({
      applyCreditErrormessage: i18n.t('invoices.message3')
    });
    setTimeout(() => {
      this.setState({
        applyCreditErrormessage: ''
      });
    }, 6000);
  };

  public debitupdatedAmount = (selectedDataVal: any) => {
    let selecteddebitamt: number = 0;
    selectedDataVal.forEach((num: any) => {
      selecteddebitamt += num.paymentAmount;
    });
    const newSelectedDebitAmt = Number(selecteddebitamt.toFixed(2));
    if (newSelectedDebitAmt === Math.abs(this.state.creditamount)) {
      this.setState({ applyCreditErrormessage: '' });
    }
    this.setState({
      selectedDebitData: selectedDataVal,
      selectedDebit: newSelectedDebitAmt
    });
  };
  public updatedAmount = (
    selectedshortpayindex: any,
    amount: any,
    selectCreditInvoices: any,
    selectedData: any
  ) => {
    this.setState({ selectedCreditData: selectedData });
    let credAmt: number = 0;
    let selectedamt: number = 0;
    credAmt = -amount;
    selectedData.forEach((num: any) => {
      selectedamt += -1 * (num.paymentAmount / 1);
    });
    this.setState({
      // creditamount: credAmt + (selectedamt - this.state.editval)
      creditamount: -selectedamt.toFixed(2)
    });
  };

  public getTargetpaymentsData = (
    listOfInvoices: number[],
    selectedInvoices: InvoiceModel[]
  ) => {
    const appliedCreditInvoices: any[] = [];
    // listOfInvoices.forEach(num => {
    //   const details = this.state.selectedCreditData.filter(
    //     newObj => newObj.invoiceNumber === num
    //   )[0];
    //   appliedCreditInvoices.push({
    //     orderNumber: details.orderNumber,
    //     paymentAmount: details.paymentAmount / 1,
    //     reasonRemainingBalance: 'Test',
    //     transactionId: details.transactionId
    //   });
    // });
    this.state.selectedDebitData.forEach(num => {
      appliedCreditInvoices.push({
        orderNumber: num.orderNumber,
        paymentAmount: Number(num.paymentAmount),
        reasonRemainingBalance: num['reasonText'] ? num['reasonText'] : '',
        transactionId: num.transactionId
      });
    });
    this.state.selectedCreditData.forEach(num => {
      appliedCreditInvoices.push({
        orderNumber: num.orderNumber,
        paymentAmount: Number(num.paymentAmount),
        reasonRemainingBalance: num['reasonText'] ? num['reasonText'] : '',
        transactionId: num.transactionId
      });
    });
    return appliedCreditInvoices;
  };

  public clickCredit = () => {
    // this.props.history.push('/invoices/applyCredit');
    const paymentdata = this.getTargetpaymentsData(
      this.state.listOfInvoices,
      this.props.selectedInvoices
    );
    let debitSum = 0;
    this.state.selectedDebitData.forEach(obj => {
      debitSum += obj.paymentAmount;
    });
    const creditInfo = {
      invoicePayments: paymentdata,
      signature: this.state.signature
    };
    // console.log('this.props.selectedInvoices>>>',this.props.selectedInvoices.length)
    // console.log('this.props.selectedCreditInvoices>>>',this.props.selectedCreditInvoices.length)

    // console.log('selectedCredit>>>',this.state.selectedCredit.length)
    // this.props.history.push({
    //   pathname: '/invoices/applyCredit',
    //   state: {
    //     orderlist: this.state.selectedDebitData,
    //     creditUsed: debitSum,
    //     debitDataList : this.props.selectedInvoices,
    //     creditDataList : this.props.selectedCreditInvoices.length > 0 ? this.props.selectedCreditInvoices: this.state.selectedCredit
    //   }
    // });
    invoiceServiceInstance
      .manualyAutoApplyCredits(creditInfo)
      .then((response: any) => {
        this.props.history.push({
          pathname: '/invoices/applyCredit',
          state: {
            orderlist: this.state.selectedDebitData,
            creditUsed: debitSum,
            debitDataList: this.state.selectedDebitData,
            creditDataList: this.state.selectedCreditData,
            paymentDetails: response.data.paymentDetails,
            paymentId: response.data.paymentId,
            totalAmount: this.state.creditamount,
            page: 'manual'
            // creditDataList:
            //   this.props.selectedCreditInvoices.length > 0
            //     ? this.props.selectedCreditInvoices
            //     : this.state.selectedCredit
          }
        });
      })
      .catch(error => {
        this.setState({
          applyCreditErrormessage: error && error.response.data.message
        });
      });
  };

  public removeViewColumnBtn = (fromCredit: any) => {
    removeColumnOrganiser();
    if (fromCredit) {
      this.setState({ showCreditTable: true });
    }
  };

  public componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getselectCredit();
    // const state: any = this.props.location?.state;
    // console.log(state);
    // if (state && state.continue === false) {
    //   this.setState({creditData:this.props.selectCreditInvoices});
    //   // creditData = this.props.selectCreditInvoices; // api
    // } else {
    //   if (this.props.selectCreditInvoices.length !== 0) {
    //     // creditData = this.props.selectedCreditInvoices;
    //     this.setState({creditData:this.props.selectedCreditInvoices});
    //   }
    //  // creditData = this.props.selectCreditInvoices;
    // }
    // // console.log('manualCredit', state);

    if (this.state.selectedDebitData.length === 0) {
      this.props.history.push({
        pathname: '/invoices'
      });
    }
  }

  public setListOfInvoicesValue = (selectedValues: any) => {
    this.setState({ listOfInvoices: selectedValues });
  };

  public checkboxcallDebit = (
    rowsSelectedpath: any,
    selectDebitInvoices: any
  ) => {
    let newDebitAmount = 0;
    selectDebitInvoices.forEach((ele: any) => {
      newDebitAmount += ele.paymentAmount;
    });
    if (this.state.selectedDebit === Math.abs(this.state.creditamount)) {
      this.setState({ applyCreditErrormessage: '' });
    }
    this.setState({
      selectedDebit: newDebitAmount,
      selectedDebitData: selectDebitInvoices
    });
  };
  public checkboxcall = (rowsSelectedpath: any, selectCreditInvoices: any) => {
    let newDebitAmount = null;
    let newCreditAmount = 0;
    let numberlist: number[] = [];
    let invoicesList: number[] = [];
    const selectCreditdataList: any = [];
    rowsSelectedpath.map((index: any) => {
      if (this.props.selectCreditInvoices.length > 0) {
        numberlist.push(this.props.selectCreditInvoices[index].orderNumber);
        invoicesList.push(this.props.selectCreditInvoices[index].invoiceNumber);
        selectCreditdataList.push(selectCreditInvoices[index]);
      }
      const remainingAmount = selectCreditInvoices[index].remainingAmount / 1;
      const paymentAmount = selectCreditInvoices[index].paymentAmount / 1;
      if (remainingAmount <= 0) {
        newCreditAmount += paymentAmount;
      } else {
        newDebitAmount = null;
      }

      // }
    });
    this.setState({
      creditamount: newCreditAmount,
      listOfOrdernumbers: numberlist,
      listOfInvoices: invoicesList,
      selectedCredit: selectCreditdataList,
      selectedCreditData: selectCreditdataList,
      applyCreditErrormessage: ''
    });
    numberlist = [];
    invoicesList = [];
  };
  public openPayPopup = () => {
    this.setState({ payAmount: !this.state.payAmount });
  };
  public render() {
    // // console.log(this.props.selectedInvoices, 'debit-invoices');
    // // console.log('called-render');
    let creditData: any[] = [];
    const state: any = this.props.location?.state;
    if (state && state.continue === false) {
      creditData = this.props.selectCreditInvoices; // api
    } else {
      if (this.props.selectCreditInvoices.length !== 0) {
        creditData = this.props.selectedCreditInvoices;
        // this.setState({creditData:this.props.selectedCreditInvoices});
      }
      // creditData = this.props.selectCreditInvoices;
    }
    const { isPending } = this.props;
    if (creditData && creditData.length > 0) {
      creditData = creditData.map((item: any, index: any) => {
        return {
          ...item,
          totalAmount: item.remainingAmount,
          paymentAmount: item.remainingAmount,
          remainingAmount: item.remainingAmount
        };
      });
    }
    return (
      <React.Fragment>
        <div className="Manual-Credit">
          <div className="apply-original">
            <div className="d-flex ht-0">
              <img
                className="image-icon"
                onClick={this.arrowBack}
                src={BackArrow}
              />
              <div className="apply-heading">
                {i18n.t('invoices.manuallySelectApplyCredit')}{' '}
              </div>
            </div>
            <div className="d-flex justify-flex-end">
              {/* <button className="cancel-btn" onClick={this.arrowBack}>
              Cancel
            </button> */}
              {/* <button className="btn" onClick={this.showPopup}>
              Apply Credits
            </button>
            <button className="btn" onClick={this.payRemaining}>
              Pay
            </button> */}
            </div>
          </div>
          {/* Mobile section for Summary Details*/}
          <div className="mobile-section paysection-open">
            <div className="pay-text">{i18n.t('invoices.youPay')}</div>
            <div className="arrow-symbol" onClick={this.openPayPopup}>
              <img
                src={this.state.payAmount === true ? DownArrowIcon : RightArrow}
              />
            </div>
          </div>
          {(this.state.payAmount === true || window.innerWidth > 1024) && (
            <div className="d-flex summary-container">
              <div className="d-flex invoices-used">
                <span className="summary">{i18n.t('invoices.summary')}</span>
                <div className="d-flex margin">
                  <span className="open-invoices">
                    {i18n.t('invoices.selectedDebit')}{' '}
                  </span>
                  <span className="credit-amount1">
                    {' '}
                    {/* $
                {state && this.state.selectedDebit === 0
                  ? state['selectedDebit'].toFixed(2)
                  : this.state.selectedDebit.toFixed(2)} */}
                    {state && this.state.selectedDebit === 0
                      ? currencyFormatter(state['selectedDebit'])
                      : currencyFormatter(this.state.selectedDebit)}
                  </span>
                </div>
                {/* <div
              className={`d-flex margin ${
                state && state.continue === false
                  ? 'display-none'
                  : 'display-none'
              }`}
            >
              <div
                className={`${
                  state && state.continue === false
                    ? 'display-block'
                    : 'display-none'
                }`}
              >
                <span className="open-invoices">Selected Credit </span>
                <span className="credit-amount1">
                  {/* ${this.state.creditamount.toFixed(2)} }
                  {currencyFormatter(this.state.creditamount)}
                </span>
              </div>
            </div> */}
                <div
                  className={`d-flex margin 
            ${
              state && state.continue === true
                ? 'display-block'
                : 'display-none'
            }
            `}
                >
                  <span className="open-invoices">
                    {i18n.t('invoices.selectedCredit')}{' '}
                  </span>
                  <span className="credit-amount1">
                    {/* {state &&
                  state['selectedCredit'] &&
                  this.state.creditamount === 0
                    ? state['selectedCredit'].toFixed(2)
                    : this.state.creditamount.toFixed(2)} */}
                    {currencyFormatter(this.state.creditamount)}
                  </span>
                </div>

                {/* <div className="d-flex margin">
              <div
                className={`  ${
                  state && state.continue === false
                    ? 'display-block'
                    : 'display-none'
                }`}
              >
                <span className="margin-rt">You Pay</span>
                <span className="credit-amount">
                  {state && this.state.selectedDebit === 0
                    ? (
                        state['selectedDebit'].toFixed(2) -
                        Math.abs(this.state.creditamount)
                      ).toFixed(2)
                    : (
                        this.state.selectedDebit -
                        Math.abs(this.state.creditamount)
                      ).toFixed(2)}
                </span>
              </div>
              <div
                className={`  ${
                  state && state.continue === true
                    ? 'display-block'
                    : 'display-none'
                }`}
              >
                <span className="margin-rt">You Pay</span>
                <span className="credit-amount">
                  {state
                    ? (
                        state['selectedDebit'] - -state['selectedCredit']
                      ).toFixed(2)
                    : ''}
                </span>
              </div>
            </div> */}
              </div>

              <div className="w-2" />
              <div className="total-pay ">
                <div
                  className={` margin available-credit ${
                    state && state.continue === false
                      ? 'display-block'
                      : 'display-none'
                  }`}
                >
                  <span className="open-invoices">
                    {i18n.t('invoices.availableCredit')} &emsp;
                  </span>
                  <span className="credit-amount">
                    {' '}
                    {/* {'$' + this.props.totalCreditmanual} */}
                    {currencyFormatter(this.props.totalCreditmanual)}
                  </span>
                </div>
              </div>
            </div>
          )}
          {this.state.applyCreditErrormessage && (
            <div>
              <br />
              <Collapse in={this.state.applyCreditErrormessage}>
                <Alert
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        this.setState({ applyCreditErrormessage: '' });
                      }}
                    >
                      <MatrialCloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                  severity="error"
                >
                  {this.state.applyCreditErrormessage}
                </Alert>
              </Collapse>
            </div>
          )}
          <div className="d-flex table-section">
            <div className="Table-width debit-table">
              <div className="select-Invoices select-pay-btn">
                {i18n.t('invoices.selectedDebitInvoices')}
                <button
                  className={`btn ${
                    this.state.selectedCreditData.length > 0 && !state.continue
                      ? 'disabled-btn'
                      : ''
                  }`}
                  onClick={this.payRemaining}
                >
                  {i18n.t('invoices.pay')}
                </button>
              </div>

              {/* {state && !state.continue && (
                <p className="debit-text">
                  The following list shows the debit invoices you selected.
                </p>
              )} */}
              <SelectedDebitInvoiceTable
                slelectedDataInvoices={this.state.selectedDebitData}
                creditdatainvoicess={this.state.selectedCredit}
                continue={state && state.continue}
                isUpdateAmount={this.debitupdatedAmount}
                isdebiteditdata={this.editdatadebit}
                handleShortPayError={this.handleShortPayErrorFn}
                isChecked={this.checkboxcallDebit}
                removeViewColumnBtn={this.removeViewColumnBtn}
              />
            </div>
            <div />
            <div className="Table-width credit-table">
              {/* <div className="d-flex justify-content-bw">
              <div
                className={`select-Invoices ${
                  state && state.continue === true
                    ? 'display-block'
                    : 'display-none'
                }`}
              >
                Selected Credit Invoices
              </div>
              <div
                className={`select-Invoices ${
                  state && state.continue === false
                    ? 'display-block'
                    : 'display-none'
                }`}
              >
                Select Credit
              </div> */}
              {/* <div
                className={`wrapper ${
                  state && state.continue === false
                    ? 'display-block'
                    : 'display-none'
                }`}
              >
                <div className="search-container">
                  <input
                    type="text"
                    placeholder=" Inv. No. "
                    onChange={this.handleChange}
                    value={this.state.searchValue}
                  />
                </div>
                <img className="search-icon" alt="search" src={SearchIcon} />
              </div> */}
              {/* <div className="rp-product-status--paginator">
                <CustomPaginator
                  activePage={1}
                  totalPages={20}
                  itemsPerPage={5}
                  onPageChanged={this.props.handlePagination}
                  totalItems={300}
                  showPageInfo={true}
                  onPageSizeChange={this.props.handlePageSizeChange}
                  showPageRangeChange={true}
                  currentPageSize={1}
                />
              </div> */}
              {/* </div> */}
              {this.state.showCreditTable && (
                <div className="select-Invoices credit-pay-btn btn-credit-sumary">
                  <span className="d-none d-md-inline">
                    {i18n.t('invoices.youHaveSelected')}{' '}
                    {this.state.selectedCreditData.length}{' '}
                    {i18n.t('invoices.creditinvoices')}
                  </span>
                  <span className="d-inline d-md-none">
                    {this.state.selectedCreditData.length}{' '}
                    {i18n.t('invoices.creditSelected')}
                  </span>
                  <div className="credit-btn-wrapper">
                    {!this.state.onCreditSummary ? (
                      <>
                        <button
                          className="btn-secondary-mannual"
                          onClick={this.onCancelCredit}
                        >
                          {i18n.t('common.cancel')}
                        </button>
                        <button
                          className="btn"
                          onClick={this.onClickCreditSummary}
                        >
                          {i18n.t('common.review')}
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="btn-secondary-mannual"
                          onClick={() =>
                            this.setState({ onCreditSummary: false })
                          }
                        >
                          {i18n.t('common.GoBack')}
                        </button>
                        <button className="btn" onClick={this.showPopup}>
                          {i18n.t('invoices.payUsingCredits')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              )}

              {state && state.continue && (
                <div className="select-Invoices credit-pay-btn">
                  {i18n.t('invoices.selectedCreditInvoices')}
                  <button className="btn" onClick={this.showPopup}>
                    {i18n.t('invoices.payUsingCredits')}
                  </button>
                </div>
              )}

              <SelectCreditTable
                // selectedinvoiceData={this.state.creditData}
                selectedinvoiceData={creditData}
                continue={state && state.continue}
                isChecked={this.checkboxcall}
                isupdated={this.updatedAmount}
                setListOfInvoices={this.setListOfInvoicesValue}
                handleShortPayError={this.handleShortPayErrorFn}
                removeViewColumnBtn={this.removeViewColumnBtn}
                showCreditTable={this.state.showCreditTable}
                onCreditSummary={this.state.onCreditSummary}
              />
            </div>
          </div>

          {this.state.showPayDisabledPopup && (
            <Modal handleCloseModal={() => console.log('Modal closed')}>
              <div className="apply-original-modal">
                <div className="d-flex justify-space-bw">
                  <div className="modal-label">
                    <b>{i18n.t('invoices.aboutApplyingPay')}</b>
                  </div>
                  <div className="close-icon" onClick={this.clickclose}>
                    <img src={CloseIcon} />
                  </div>
                </div>
                <div className="modal-content">
                  {i18n.t('invoices.message4')}
                </div>
                <div className="text-align-center">
                  <button className="ok-btn mr-20" onClick={this.clickclose}>
                    {i18n.t('invoices.oK')}
                  </button>
                </div>
              </div>
            </Modal>
          )}
          {this.state.showdisabledPopup ? (
            <div>
              <Modal handleCloseModal={() => console.log('Modal closed')}>
                <div className="apply-original-modal">
                  <div className="d-flex justify-space-bw">
                    <div className="modal-label">
                      <b>{i18n.t('invoices.applyingCredit')}</b>
                    </div>
                    <div className="close-icon" onClick={this.clickclose}>
                      <img src={CloseIcon} />
                    </div>
                  </div>
                  <div className="modal-content">
                    {i18n.t('invoices.toPay')}{' '}
                    {this.state.selectedDebit === 0
                      ? this.props.location?.state['selectedDebit'] <=
                        Math.abs(this.state.creditamount)
                        ? currencyFormatter(
                            this.props.location?.state['selectedDebit']
                          )
                        : currencyFormatter(Math.abs(this.state.creditamount))
                      : this.props.location?.state['selectedDebit'] <=
                        Math.abs(this.state.creditamount)
                      ? currencyFormatter(this.state.selectedDebit)
                      : currencyFormatter(
                          Math.abs(this.state.creditamount)
                        )}{' '}
                    {i18n.t(
                      'invoices.usingyourcredityoumustprovideyoursignature'
                    )}
                  </div>
                  <Input
                    label="Enter your Full Name"
                    onChange={this.handleInput}
                    value={this.state.input}
                    className="rp-forgotpassword--input"
                  />
                  {this.props.location?.state['selectedDebit'] <=
                  Math.abs(this.state.creditamount) ? (
                    ``
                  ) : (
                    <div className="text-align-left mb-10">
                      <Collapse
                        in={this.props.location?.state['selectedDebit']}
                      >
                        <Alert severity="error">
                          {i18n.t('invoices.verbiage')}
                        </Alert>
                      </Collapse>
                    </div>
                  )}
                  <div className="text-align-center">
                    <button className="ok-btn mr-20" onClick={this.clickclose}>
                      {i18n.t('common.cancel')}
                    </button>
                    <button className="ok-btn" onClick={this.applyCredits}>
                      {i18n.t('common.continueActionTxt')}
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          ) : (
            ''
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default ManuallyCredit;
